import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/apiClient";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Mail, ArrowLeft, MailCheck } from "lucide-react";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim(), base_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#eef4ff] to-slate-100 flex items-center justify-center p-5">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-3xl shadow-xl border border-slate-100 p-7">
          <div className="flex items-center gap-3 mb-5">
            <img src="/logo-clima-branca-icon.png" alt="Clima Branca" className="h-11 w-11 rounded-xl object-cover" />
            <div className="leading-tight">
              <span className="text-lg font-bold text-slate-800 block">Clima Branca</span>
              <span className="text-[11px] font-semibold tracking-widest text-slate-400 uppercase">Soluções em climatização</span>
            </div>
          </div>

          {sent ? (
            <div className="text-center py-4" data-testid="forgot-sent">
              <div className="h-14 w-14 rounded-full bg-emerald-50 flex items-center justify-center mx-auto mb-4">
                <MailCheck className="h-7 w-7 text-emerald-600" />
              </div>
              <h1 className="text-xl font-bold text-slate-800">Verifique seu e-mail</h1>
              <p className="text-sm text-slate-500 mt-2">
                Se o e-mail estiver cadastrado, enviamos um link para redefinir sua senha. O link expira em 1 hora.
              </p>
              <Link to="/" className="inline-flex items-center gap-1.5 text-blue-600 font-semibold mt-6 hover:underline" data-testid="back-to-login-link">
                <ArrowLeft className="h-4 w-4" /> Voltar ao login
              </Link>
            </div>
          ) : (
            <>
              <h1 className="text-2xl font-bold text-slate-800">Esqueceu a senha?</h1>
              <p className="text-sm text-slate-500 mt-1 mb-5">Informe o e-mail do seu cadastro e enviaremos um link para criar uma nova senha.</p>
              <form onSubmit={submit} className="space-y-4">
                <div className="space-y-1.5">
                  <label htmlFor="email" className="text-sm font-medium text-slate-600">E-mail</label>
                  <div className="relative">
                    <Mail className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400" />
                    <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
                      placeholder="seu@email.com" className="pl-9 h-12 rounded-xl bg-slate-50 border-slate-200"
                      data-testid="forgot-email-input" />
                  </div>
                </div>
                <Button type="submit" disabled={loading}
                  className="w-full h-12 rounded-xl bg-gradient-to-r from-[#1e7be0] to-[#0f3d92] hover:from-[#1a6fce] hover:to-[#0c3382] text-base font-semibold"
                  data-testid="forgot-submit-button">
                  {loading ? "Enviando..." : "Enviar link de redefinição"}
                </Button>
              </form>
              <Link to="/" className="flex items-center justify-center gap-1.5 text-sm text-slate-500 mt-5 hover:text-slate-700" data-testid="back-to-login-link">
                <ArrowLeft className="h-4 w-4" /> Voltar ao login
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
